import { createContext } from "react";
import { useEffect, useState } from "react";
import { useWindowSize } from "../Hooks/useWindowSize";

export const MediaQueryContext = createContext(null);

// Follows TailwindCss responsiveness guidelines
// https://tailwindcss.com/docs/responsive-design
const defaultSizesInPx = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

/**
 * @returns {{[key: string]: boolean}}
 */
export const MediaQueryContextProvider = ({ children }) => {
  const [minSize, setMinSizes] = useState({
    sm: false,
    md: false,
    lg: false,
    xl: false,
    "2xl": false,
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  const { width } = useWindowSize();

  useEffect(() => {
    const minSize = Object.keys(defaultSizesInPx).reduce((obj, key) => {
      obj[key] = defaultSizesInPx[key] < width;
      return obj;
    }, {});

    const values = { ...minSize, isMobile: !minSize.sm, isTablet: minSize.md && !minSize.lg, isDesktop: minSize.lg };
    setMinSizes(values);
  }, [width]);

  return <MediaQueryContext.Provider value={minSize}> {children} </MediaQueryContext.Provider>;
};

export default MediaQueryContext;
